<template>
  <layout-guest>
    <v-form
      v-model="formulario"
      @submit.prevent="post_company_data"
      ref="formuarioCompanyData"
      autocomplete="off"
    >
      <v-container class="py-8">
        <v-row class="py-8">
          <v-col cols="12">
            <main-progres />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <h1 class="text-h4 font-weight-light py-5">
              {{ $t("supplierData.referenciaProvedor") }}
            </h1>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <h2 class="text-h5 font-weight-light">
              {{ $t("supplierData.datosEmpresa") }}
            </h2>
          </v-col>
        </v-row>

        <v-row class="pb-5">
          <v-col cols="12" sm="12" md="6" lg="3">
            <label>{{ $t("supplierData.nifcifnie") }}</label>
            <v-text-field
              :rules="[rules.required, rules.minNif, rules.maxNif]"
              counter
              maxlength="15"
              minlength="8"
              v-on:change="changeSupplierId"
              @keyup="form.supplierId = form.supplierId.toUpperCase()"
              :color="entityConfig.primaryColor"
              id="nif"
              dense
              outlined
              placeholder="00000000A"
              v-model="form.supplierId"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="6" lg="3">
            <label style="padding-right: 10px"
              >{{ $t("supplierData.refenciaProvedor") }}
            </label>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  :color="entityConfig.primaryColor"
                  >mdi-chat-alert-outline</v-icon
                >
              </template>
              <span
                >Identificador único que le hemos enviado informándole de la
                posibilidad de adelantar el cobro de su factura</span
              >
            </v-tooltip>
            <v-text-field
              :rules="[rules.required]"
              counter
              maxlength="14"
              hint="14 caracteres"
              :color="entityConfig.primaryColor"
              id="referenceProvedor"
              dense
              outlined
              placeholder="00000000A"
              @keyup="form.supplierReference = form.supplierReference.toUpperCase()"
              v-model="form.supplierReference"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <h2 class="text-h5 font-weight-light">
              {{ $t("supplierData.datosFactura") }}
            </h2>
          </v-col>
        </v-row>

        <v-row class="pb-5">
          <v-col sm="12" md="4" lg="3">
            <label>{{ $t("supplierData.numeroDeFactura") }}</label>
            <v-text-field
              :rules="[rules.maxRefenciaProvedor, rules.required]"
              hint="20 caracteres"
              :color="entityConfig.primaryColor"
              dense
              outlined
              v-model="form.invoiceNumber"
              max="20"
              maxlength="20"
              counter
              placeholder="Escriba el n° de factura"
            ></v-text-field>
          </v-col>

          <v-col sm="12" md="4" lg="3">
            <label>{{ $t("supplierData.importe") }}</label>

            <v-currency-field
              :color="entityConfig.primaryColor"
              dense
              outlined
              :placeholder="$t('invoices.escribaImporte')"
              appendIcon="mdi-currency-eur"
              append-icon="mdi-euro"
              :rules="[rules.required, rules.quinceEnteros]"
              v-model="form.invoiceAmount"
              maxlength="18"
            />
          </v-col>

          <v-col cols="12" md="4" lg="3">
            <label>{{ $t("supplierData.fechaVenciminto") }}</label>

            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :rules="[rules.required]"
                  readonly
                  outlined
                  dense
                  placeholder="DD / MM / YYYY"
                  v-model="computedDateFormatted"
                  :color="entityConfig.primaryColor"
                  persistent-hint
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  @blur="date = parseDate(date)"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                :locale="$i18n.locale"
                :color="entityConfig.primaryColor"
                v-model="date"
                no-title
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row class="pb-5">
          <v-col cols="12" xs="12" lg="9">
            <checkbox-terms :checkboxData="entityConfig.checkboxCompanyData" @accepted="checkbox = true" @canceled="checkbox = false" :externalState="expandedState" />
          </v-col>
          <v-col cols="12" sm="12" lg="12">
            <v-btn
              depressed
              :disabled="!formIsValid"
              :color="entityConfig.primaryColor"
              :style="`color: ${entityConfig.secondaryColor}`"
              @click="post_company_data"
              class="float-end m-2 v-btn-width-default"
            >
              {{ $t("supplierData.siguiente") }}
            </v-btn>
            <router-link to="/">
              <v-btn
                outlined
                :color="entityConfig.primaryColor"
                class="float-end m-2 v-btn-width-default"
              >
                {{ $t("supplierData.cancelar") }}
              </v-btn>
            </router-link>
          </v-col>
        </v-row>
      </v-container>
      <overlay :visible="spinner" :opacity="1"></overlay>
    </v-form>
  </layout-guest>
</template>

<script>
import LayoutGuest from "../../components/layouts/layout-guest.vue";
import Overlay from "../../components/layouts/overlay.vue";
import Progres from "../../components/global/progres_init.vue";
import passwordValidator from "password-validator";
import CheckboxTerms from "../../components/layouts/checkbox-terms.vue";
import Api from "../../Services/index";

import { mapMutations, mapState } from "vuex";

export default {
  components: {
    Overlay,
    "main-progres": Progres,
    "layout-guest": LayoutGuest,
    "checkbox-terms": CheckboxTerms
  },
  data(vm) {
    return {
      authToken:{},
      basePath: process.env.VUE_APP_CONTEXT_PATH,
      date: "",
      checkbox: false,
      entityConfig: {},

      dateFormatted: vm.formatDate(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10)
      ),
      formulario: false,
      menu1: false,
      spinner: false,
      form: {
        codNrbeEn: "",
        invoiceAmount: null,
        invoiceNumber: "",
        supplierId: "",
        supplierReference: "",
        invoiceDueDate: "",
      },

      rules: {
        ValidatorHasNumber: (v) => {
          var schema = new passwordValidator();
          schema.has().digits(10);
          return schema.validate(v) || "Debe ser numérico";
        },

        isNumeric: (v) => /[0-9]+$/.test(v) || "Solo caracteres numericos",

        referenceValidatorHasNumber: (v) => {
          var schema = new passwordValidator();
          schema.has().digits(1);
          return schema.validate(v) || "Debe ser numérico";
        },
        quinceEnteros: () => (this.form.invoiceAmount < 1000000000000000) || "El importe no debe contener mas de quince enteros y dos decimales",

        nifValidate: (value) => {
          var regex = /^(\d{8})([A-Z])$/;

          return regex.test(value) || "NIF inválido";
        },
        cifValidate: (value) => {
          var regex = /^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/;
          return regex.test(value) || "CIF inválido";
        },

        nieValidate: (value) => {
          var regex = /^[XYZ]\d{7,8}[A-Z]$/;
          return regex.test(value) || "NIE inválido";
        },
        maxImporte: (v) =>
          v.length <= 15 || "Su cantidad excede el monto autorizado ",
        maxNif: (v) => v.length <= 15 || "15 caracteres maximo",
        minNif: (v) => v.length >= 8 || "8 caracteres minimo",
        maxRefenciaProvedor: (v) => v.length <= 20 || "20 caracteres maximo",
        minRefenciaProvedor: (v) => v.length >= 1 || "1 caracteres minimo",

        maxInvoiceAmount: (v) => v.length <= 9 || " caracteres maximo",

        required: (value) => !!value || "Este campo es requerido..",

        email: (value) => {
          const pattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/
          return pattern.test(value) || "E-mail inválido.";
        },

        emailMatch: () => `The email and password you entered don't match`,
      },
    };
  },

  mounted() {
    this.entityConfig = this.$store.state.entityConfig.config;
    Api.defaults.headers.common["Authorization"] =
      "Bearer " + sessionStorage.getItem("authtoken");
    sessionStorage.removeItem("token");
    this.form.codNrbeEn = sessionStorage.getItem("codNrbeEn");
    sessionStorage.removeItem("supplierId");
  },

  computed: {
    ...mapState("companyData", ["supplierId", "codNrbeEn"]),

    computedDateFormatted() {
      return this.formatDate(this.date);
    },

    supplierIdIsValid() {
      return !!this.form.supplierId;
    },

    expandedState() {
      let value = !(this.form.supplierReference || this.form.invoiceNumber || this.form.supplierId || this.form.invoiceAmount);
      return value
    },

    supplierReferenceIsValid() {
      return !!this.form.supplierReference;
    },

    invoiceNumberIsValid() {
      return !!this.form.invoiceNumber;
    },

    invoiceAmountValid() {
      return !!this.form.invoiceAmount;
    },

    invoiceDueDateIsValid() {
      return !!this.form.invoiceDueDate;
    },

    formIsValid() {
      return this.formulario && this.checkbox;
    },
  },

  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
    },
  },

  methods: {
    nifValid(value) {
      var DNI_REGEX = /^(\d{8})([A-Z])$/;
      var CIF_REGEX = /^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/;
      var NIE_REGEX = /^[XYZ]\d{7,8}[A-Z]$/;
      return (
        DNI_REGEX.test(value) ||
        CIF_REGEX.test(value) ||
        NIE_REGEX.test(value) ||
        "Numero de indetificacion inválido"
      );
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${day}-${month}-${year}`;
    },

    async post_company_data() {
      try {
        let [d, m, y] = this.dateFormatted.split("/");
        let date = `${y}-${m}-${d}`;
        this.form.invoiceDueDate = date;
        this.spinner = true;
        const formData = new FormData();
        formData.append("codNrbeEn", this.form.codNrbeEn);
        formData.append("invoiceAmount", this.form.invoiceAmount);
        formData.append("invoiceNumber", this.form.invoiceNumber);
        formData.append("supplierId", this.form.supplierId);
        formData.append("supplierReference", this.form.supplierReference);
        formData.append("invoiceDueDate", this.form.invoiceDueDate);

        const obj = Object.fromEntries(formData);

        const response = await Api.post(
          `/proveedores/${this.form.supplierId}/validacion`,
          obj
        );
         this.authToken = response.data.response.token;
        const base64Payload = this.authToken.split(".")[1];
          const userData = decodeURIComponent(
            escape(window.atob(base64Payload))
          );

        sessionStorage.setItem("supplierName", userData);
        sessionStorage.setItem("token", response.data.response.token);
        sessionStorage.setItem("supplierId", this.form.supplierId);
        this.spinner = false;
        this.$router.push({ path: "access-data" });
      } catch (error) {
        this.$showError(this, error.response.data);
      } finally {
        this.spinner = false;
      }
    },

    ...mapMutations("companyData", ["changeSupplierId"]),
  },
};
</script>
